import Vue from 'vue'
import Vuex from 'vuex'

import vuejsStorage from 'vuejs-storage'

import { isEmpty } from 'lodash'

/*
  업무용 로컬 스토어 샘플
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

/*
  return
   - vue intance를 식별하기 위한 unique id
*/
const getName = () => {
  return 'mmpAuth'
}

/*
   return
    - localstore 저장용 vue instance
*/
const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        saveId: '',
        autoLogin: false,
        session: {},
        token: {},
        beforeRoute: {},
        basePath: '',
        isMain: true,
        wepSets: {}
      },
      getters: {
        isAutoLogin: state => {
          return (state.autoLogin && !isEmpty(state.session) && !isEmpty(state.token))
        },
        isSaveId: state => {
          return !isEmpty(state.saveId)
        },
        getBeforeRoute: (state) => (defaultRoute) => {
          return isEmpty(state.beforeRoute) ? defaultRoute : state.beforeRoute
        }
      },
      mutations: {
        // 토큰 저장
        SET_AUTO_LOGIN (state, {session, token}) {
          Vue.set(state, 'session', session)
          Vue.set(state, 'token', token)
          if (!isEmpty(state.session) && !isEmpty(state.token)) {
            state.autoLogin = true
          } else {
            state.autoLogin = false
          }
        },
        CLEAR_AUTO_LOGIN (state) {
          Vue.set(state, 'session', {})
          Vue.set(state, 'token', {})
          state.autoLogin = false
        },
        SET_SAVE_ID (state, userId) {
          if (isEmpty(userId)) {
            state.saveId = ''
          } else {
            state.saveId = userId
          }
        },
        SET_BASE_PATH (state, basePath) {
          if (isEmpty(basePath)) {
            state.basePath = ''
          } else {
            state.basePath = basePath
          }
        },
        SET_BEFORE_ROUTE (state, next) {
          Vue.set(state, 'beforeRoute', next)
        },
        SET_IS_MAIN (state, isMain) {
          state.isMain = isMain
        },
        SET_IS_WEPSETS (state, wepSets) {
          if (isEmpty(wepSets)) {
            state.wepSets = ''
          } else {
            state.wepSets = wepSets
          }
        }
      },
      plugins: [
        vuejsStorage({
          keys: ['saveId'],
          namespace: 'mmp-app-mmpAuth-saveId',
          driver: vuejsStorage.drivers.localStorage
        }),
        vuejsStorage({
          keys: ['basePath'],
          namespace: 'mmp-app-mmpAuth-basePath',
          driver: vuejsStorage.drivers.localStorage
        }),
        vuejsStorage({
          keys: ['autoLogin'],
          namespace: 'mmp-app-mmpAuth-autoLogin',
          driver: vuejsStorage.drivers.localStorage
        }),
        vuejsStorage({
          keys: ['token'],
          namespace: 'mmp-app-mmpAuth-token',
          driver: vuejsStorage.drivers.localStorage
        }),
        vuejsStorage({
          keys: ['session'],
          namespace: 'mmp-app-mmpAuth-session',
          driver: vuejsStorage.drivers.localStorage
        }),
        vuejsStorage({
          keys: ['isMain'],
          namespace: 'mmp-app-mmpAuth-isMain',
          driver: vuejsStorage.drivers.localStorage
        }),
        vuejsStorage({
          keys: ['wepSets'],
          namespace: 'mmp-app-mmpAuth-wepSets',
          driver: vuejsStorage.drivers.localStorage
        })
      ]
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/config/vuex/mmpAuth.js